module.exports = __webpack_public_path__ + "Logo_Inventario.png?5b7aa02f7a77298578b2dba4a9e7c28e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Logo_Inventario.png
// module id = 1996
// module chunks = 0